export const check = {
    companyId: "",
    masterId: 0,
    enable: false,
    xWebId: "",
    apiKey:"",
    merchantId:"",
    webToken:"",
    terminalId: "",
    authKey: "",
    termsAndConditions: "",
    staxEnable: false,
};

export const objError = {
    xWebId: {
        status: false,
        message: "",
    },
    terminalId: {
        status: false,
        message: "",
    },
    authKey: {
        status: false,
        message: "",
    },
    apiKey: {
        status: false,
        message: "",
    },
    webToken: {
        status: false,
        message: "",
    },
    merchantId: {
        status: false,
        message: "",
    }
};

export const X_WEB_ID = "xWebId";
export const TERMINAL_ID = "terminalId";
export const AUTH_KEY = "authKey";
export const X_WEB_ID_MANDATORY = "XWebID is mandatory";
export const TERMINAL_ID_MANDATORY = "Terminal ID is mandatory";
export const AUTH_KEY_MANDATORY = "Auth Key is mandatory";
export const DETAILS_INVALID = "Details do not match, try again";
export const ACH = "ach";
export const ACH_TITLE = "ACH";
export const CC_TITLE = "Credit Card";
export const CC_LABEL = "CC";